var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.243 2.59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4,18.8H2.111A2.112,2.112,0,0,1,0,16.695V2.934A2.114,2.114,0,0,1,2.111.822H8.077a.839.839,0,0,1,0,1.678H2.11a.437.437,0,0,0-.436.436V16.7a.437.437,0,0,0,.436.436H15.4a.437.437,0,0,0,.437-.436V11.918a.84.84,0,0,1,1.68,0v4.774A2.114,2.114,0,0,1,15.4,18.8ZM7.465,10.3a.657.657,0,0,1-.12-.01.84.84,0,0,1-.71-.949A8.5,8.5,0,0,1,7.913,6.152,7.052,7.052,0,0,1,13.4,2.97V.839A.837.837,0,0,1,14.239,0a.826.826,0,0,1,.576.232l4.453,4.24a.848.848,0,0,1-.04,1.254l-4.456,3.71a.839.839,0,0,1-.535.193.805.805,0,0,1-.354-.08.841.841,0,0,1-.485-.759V6.2a.839.839,0,0,1,1.679,0V7l2.357-1.964L15.08,2.793v.987a.84.84,0,0,1-.839.839l-.052,0-.033,0A5.478,5.478,0,0,0,9.338,7.043,7.058,7.058,0,0,0,8.294,9.586.845.845,0,0,1,7.465,10.3Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreated);
export default __webpack_public_path__ + "static/media/created.b1d63920.svg";
export { ForwardRef as ReactComponent };